module.exports = __webpack_public_path__ + "static/media/reading.f867d2a1.png";